export default {
    title: 'VERI*FACTU',
    whatIs: {
        title: 'O que é VERI*FACTU?',
        p1: 'VERI*FACTU não é um software em si, mas um conjunto de requisitos técnicos e legais que os Sistemas Informáticos de Faturamento (SIF) na Espanha devem cumprir.',
        p2: 'Seu objetivo: garantir a transparência, rastreabilidade e integridade das faturas — impedir manipulações, contabilidades paralelas («caixa B»), exclusões ou alterações de registros.'
    },
    whoIsAffected: {
        title: 'Quem é afetado?',
        p1: 'Afeta empresas, profissionais e autônomos que usam sistemas informáticos ou eletrônicos para emitir faturas.',
        p2: 'Se uma pessoa emite faturas manualmente — por exemplo, com um simples documento impresso ou modelo sem funcionalidades contábeis — não seria obrigada a cumprir o VERI*FACTU.'
    },
    requirements: {
        title: 'Principais requisitos dos sistemas de faturamento com VERI*FACTU',
        intro: 'Quando você usa um SIF, ele deve cumprir vários critérios técnicos e de segurança:',
        li1: 'Registro automático e único para cada fatura emitida (incluindo novas faturas, cancelamentos ou retificações).',
        li2: 'Inalterabilidade dos registros: as faturas não podem ser modificadas ou excluídas sem deixar rastro; são usadas assinaturas eletrônicas, hashes encadeados ou outros mecanismos seguros.',
        li3: 'Rastreabilidade e conservação: os registros devem ser mantidos acessíveis, legíveis e conservados em condições que permitam sua consulta se a autoridade o exigir.',
        li4: 'Identificação “Veri*Factu” na fatura: quando este sistema é usado, a fatura deve alertar que foi gerada sob VERI*FACTU e, geralmente, incluir um código QR com dados de identificação.',
        li5: 'Possibilidade de envio à Agência Tributária (AEAT): os sistemas devem permitir, se desejado, enviar os registros de faturamento à AEAT, preferencialmente em tempo real ou imediatamente antes de emitir a fatura.'
    },
    optionVerifactu: {
        title: 'Opção Verifactu',
        p1: 'Antes de escolher a opção Verifactu, o usuário deve saber que esta opção deve ser mantida durante o ano atual, ou seja, não será possível mudar para outra opção até 1º de janeiro do ano seguinte.',
        p2: 'Com a opção Verifactu, uma vez enviadas as faturas, serão gerados automaticamente os arquivos XML e enviados à AEAT, conforme exigido.',
        p3: 'As informações sobre este processo podem ser vistas na aba Eventos, dentro dos detalhes da fatura enviada.',
        p4: 'Também será possível ver o código QR gerado no PDF da fatura, no início do mesmo.'
    },
    optionNoVerifactu: {
        title: 'Opção Não Verifactu',
        p1: 'Se a opção Não Verifactu for escolhida, a plataforma gerará automaticamente os arquivos XML para cada fatura enviada, mas esses arquivos serão mantidos armazenados internamente, sem serem enviados à AEAT, até que esta os solicite ao usuário.',
        p2: 'Nesse momento, o usuário entrará em contato conosco e então enviaremos os arquivos solicitados.'
    },
    deadlines: {
        title: 'Prazos de implementação',
        p1: 'A obrigação efetiva de usar software compatível recai sobre as empresas — especialmente sociedades — a partir de 1º de janeiro de 2027. Para autônomos e profissionais, o prazo se estende até julho de 2027.',
        p2: "Embora o uso do “modo VERI*FACTU” não seja obrigatório para todos — pode-se optar por manter registros internamente — opção 'Não Verifactu', o software deve cumprir os requisitos do regulamento."
    },
    why: {
        title: 'Por que o VERI*FACTU está sendo promovido?',
        intro: 'Os principais objetivos são:',
        li1: 'Combater a fraude fiscal reduzindo o uso de contabilidades paralelas.',
        li2: 'Garantir a transparência, integridade e confiabilidade do faturamento na Espanha.',
        li3: 'Acompanhar a digitalização da gestão de faturas e adaptar-se aos novos tempos, com sistemas seguros, estruturados e verificáveis.'
    },
    documentation: {
        title: 'Documentação oficial',
        link1Text: 'Real Decreto 254/2025',
        link1Suffix: ', de 1 de abril, que altera o Real Decreto 1007/2023, de 5 de dezembro, que aprova o Regulamento que estabelece os requisitos que devem ser adotados pelos sistemas e programas informáticos ou eletrônicos que suportam os processos de faturamento de empresários e profissionais, e a padronização dos formatos dos registros de faturamento.',
        link2Text: 'Perguntas frequentes feitas por empresas, PMEs e autônomos.'
    },
    requerimiento: {
        title: 'Envio por requerimento',
        numeroRequerimiento: {
            label: 'Número de requerimento',
            helper: 'Máx. 18 caracteres'
        },
        filter: {
            title: 'Pesquisa de faturas',
            period: 'Período de pesquisa',
            from: 'De',
            to: 'Até'
        },
        modal: {
            title: 'Número de requerimento'
        },
        table: {
            serieFactura: 'Série',
            numeroFactura: 'Nº fatura',
            fechaExpedicionFactura: 'Data de emissão',
            razonSocialEmisor: 'Fornecedor',
            razonSocialDestinatario: 'Destinatário',
            importeTotal: 'Montante'
        },
        button: {
            send: 'Enviar selecionadas',
            back: 'Voltar'
        },
        empty: 'Não há faturas pendentes de requerimento',
        notRegisteredModality: 'Não está registado na modalidade VeriFactu de requerimento. Esta secção está disponível apenas para utilizadores com essa modalidade.',
        result: {
            title: 'Resultado do envio',
            numeroRequerimiento: 'Número de requerimento',
            nRegistros: 'Nº registos',
            finRequerimiento: 'Fim do requerimento',
            pendientes: 'Pendentes',
            error: 'Erro',
            estadoEnvio: 'Estado do envio',
            csv: 'CSV',
            yes: 'Sim',
            no: 'Não'
        }
    },
    enviadas: {
        title: 'Verifactu - Faturas remitidas',
        table: {
            idFactura: 'Id Fatura',
            modalidad: 'Modalidade',
            fechaHoraEnvio: 'Data/hora de envio',
            download: 'Descarregar'
        },
        modalidad: {
            voluntario: 'Voluntário',
            requerimiento: 'Requerimento'
        },
        errors: {
            download: 'Não foi possível descarregar o ficheiro da fatura'
        },
        empty: 'Não há faturas enviadas para VeriFactu'
    },
    comprobarHuella: {
        title: 'Verificar hash',
        empty: 'Não há registos para verificar',
        tabs: {
            facturacion: 'Faturação',
            eventos: 'Eventos'
        },
        table: {
            idFactura: 'Id Fatura',
            serie: 'Série',
            numero: 'Número',
            fechaExpedicion: 'Data de emissão',
            importe: 'Valor',
            id: 'Id',
            tipoEvento: 'Tipo de evento',
            fechaHora: 'Data/hora',
            comprobar: 'Verificar'
        },
        eventTypes: {
            '01': 'Início de funcionamento do SIF',
            '02': 'Fim de funcionamento do SIF',
            '03': 'Lançamento de anomalias de faturação',
            '04': 'Deteção de anomalias de faturação',
            '05': 'Lançamento de anomalias de eventos',
            '06': 'Deteção de anomalias de eventos',
            '07': 'Restauração de cópia de segurança',
            '08': 'Exportação de registos de facturação',
            '09': 'Exportação de registos de eventos',
            '10': 'Resumo de eventos',
            '90': 'Outros eventos voluntários'
        },
        resultado: {
            title: 'Resultado da verificação',
            campo: 'Campo',
            valor: 'Valor',
            valida: 'Hash válido',
            noValida: 'Hash NÃO válido',
            tipoRegistro: 'Tipo de registo',
            tipoEvento: 'Tipo de evento',
            idFactura: 'Id Fatura',
            idEvento: 'Id Evento',
            serie: 'Série',
            numero: 'Número',
            fechaExpedicion: 'Data de emissão',
            fechaHora: 'Data/hora',
            huellaCalculada: 'Hash calculado',
            huellaEsperada: 'Hash armazenado',
            cadenaReferencia: 'Cadeia de referência',
            anterior: 'Registo anterior',
            id: 'Id'
        },
        errors: {
            comprobar: 'Não foi possível verificar o hash do registo'
        }
    },
    exportarRegistros: {
        title: 'Verifactu - Exportar registos',
        nif: 'NIF',
        intro: 'Gera os ficheiros ZIP com as faturas e os eventos registados no período selecionado, mesmo que já tenham sido exportados anteriormente.',
        filter: {
            title: 'Pesquisa de registos',
            period: 'Período de exportação',
            from: 'Desde',
            to: 'Até'
        },
        button: 'Exportar registos',
        processing: 'A gerar eventos...',
        result: {
            ok: 'Gerado(s) {count} ficheiros(s) para o NIF {nif}',
            ko: 'Erro na exportação para o NIF {nif}'
        },
        downloadFacturacion: 'Transferir faturação (ZIP)',
        downloadEventos: 'Transferir eventos (ZIP)'
    }
}
